import { render, staticRenderFns } from "./ReviewAndFinish.vue?vue&type=template&id=0ec48afe&scoped=true"
import script from "./ReviewAndFinish.vue?vue&type=script&lang=js"
export * from "./ReviewAndFinish.vue?vue&type=script&lang=js"
import style0 from "./ReviewAndFinish.vue?vue&type=style&index=0&id=0ec48afe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec48afe",
  null
  
)

export default component.exports